// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_x3I","cls2":"FocusedNav-cls2_2FS FocusedNav-cls1_x3I"};